import type { Data } from "../api/inventory/getConfig";

// default rarities
export const NFT_RARITY = {
	COMMON: "common",
	RARE: "rare",
	LEGENDARY: "legendary",
} as const;

export type NFTRarity = (typeof NFT_RARITY)[keyof typeof NFT_RARITY];

export const createNFTRarityOptions = (rarities: Data["rarities"]) => {
	return rarities.map((rarity) => ({
		value: rarity.toLowerCase(),
		label: rarity.charAt(0).toUpperCase() + rarity.slice(1).toLowerCase(),
	}));
};
